/* eslint-disable max-len */
import { takeLatest, put, call } from 'redux-saga/effects'
import { getRequest } from '../../../../utils/User/axios'
import {
  getPesticideByRequest, getPesticideBySuccess, getPesticideByFailed,
  getPesticideByFilterFailed, getPesticideByFilterSuccess, getPesticideByFilterRequest,
} from '../Reducer'

export default function* getPesticideByWatcherSaga() {
  yield takeLatest(getPesticideByRequest.type, getPesticideBySaga)
  yield takeLatest(getPesticideByFilterRequest.type, getPesticideFilterSaga)
}

const getPesticideBy = (prmAry) => getRequest(`${ process.env.REACT_APP_URL }/pesticide-by?${ prmAry[ 0 ] }=${ prmAry[ 1 ] }`)

const getFilteredPesticides = ({ text }) => getRequest(`${ process.env.REACT_APP_URL }/filter-pesticide-by?text=${ text }`)

function* getPesticideBySaga({ payload }) {
  try {
    const response = yield call(getPesticideBy, payload)
    yield put(getPesticideBySuccess(response.data))
  } catch (error) {
    yield put(getPesticideByFailed(error))
  }
}

function* getPesticideFilterSaga({ payload }) {
  try {
    const response = yield call(getFilteredPesticides, payload)
    yield put(getPesticideByFilterSuccess(response.data))
  } catch (error) {
    yield put(getPesticideByFilterFailed(error))
  }
}
